import { useEffect } from 'react';

export function useTrackingPixel(pixelId) {
  useEffect(() => {
    if (!pixelId || !/^\d{10,16}$/.test(pixelId)) return;

    const injected = [];

    // Inline Meta Pixel init script
    const initScript = document.createElement('script');
    initScript.textContent = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${pixelId}');fbq('track','PageView');`;
    document.head.appendChild(initScript);
    injected.push(initScript);

    // Noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    injected.push(noscript);

    return () => {
      injected.forEach((el) => {
        try { document.head.removeChild(el); } catch {}
      });
      // Clean up fbq
      try { delete window.fbq; delete window._fbq; } catch {}
    };
  }, [pixelId]);
}
